import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Sidebar, MobileBar } from "./Sidebar";
import { getMerchantId } from "../lib/api";

export const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const merchantId = getMerchantId();
  if (!merchantId) return <Navigate to="/install" replace state={{ from: location }} />;
  return (
    <div className="App flex bg-cream min-h-screen">
      <Sidebar />
      <main className="flex-1 min-w-0 px-6 sm:px-10 lg:px-14 py-10 pb-24 lg:pb-10">{children}</main>
      <MobileBar />
    </div>
  );
};
